import React, { Component } from 'react';
import {CmsCliente} from '../../Values.js';

class Footer extends Component {

    render() {
        const year = new Date().getFullYear()
        return (
            <footer className="footer-container">
                <span>&copy; {year} - Administrador NORMA 035 - {"v." + CmsCliente.Version}</span>
            </footer>
        );
    }

}

export default Footer;
